import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDialogAccountMenu, LazyDialogAddCreditCard, LazyDialogAddress, LazyDialogBirthdayClaim, LazyDialogCancelOrder, LazyDialogCreditHowItWorks, LazyDialogDeleteAddress, LazyDialogDeleteCard, LazyDialogMoreWaysToEarnOffer, LazyDialogMoreWaysToEarn, LazyDialogSmsNotifications, LazyDialogTrackOrder, LazyDialogTrackShipments, LazyCmsEventCollection, LazyCmsMegaMenuL1Desktop, LazyCmsMegaMenuL1DesktopLegacy, LazyCmsMegaMenuL1DesktopV2, LazyCmsMegaMenuL1Mobile, LazyCmsMegaMenuL2Mobile, LazyCmsPromoBar, LazyCmsPromoBarLinks, LazyCmsPromoBarMessage, LazyCmsPromoBarUtilities, LazyCmsRecommendationCarousel, LazyDialogAddGiftOption, LazyDialogAccount, LazyDialogEventDetail, LazyDialogFilters, LazyDialogHowMetersWorks, LazyDialogLocationConfirmation, LazyDialogMegaMenu, LazyDialogPickupInStore, LazyDialogProductDetails, LazyDialogPromoBar, LazyDialogQuickshopElevate, LazyDialogShippingAddress, LazyDialogShopTheLook, LazyCmsAccordions, LazyCmsAnchor, LazyCmsArticleCarousel, LazyCmsArticleGridV2, LazyCmsArticleGrid, LazyCmsBannerBlockBelow, LazyCmsBannerBlurredSplit, LazyCmsBannerEspot, LazyCmsBannerImage, LazyCmsBannerImageStandard, LazyCmsBannerMenu, LazyCmsBannerOverlay, LazyCmsBannerSaleSplit, LazyCmsBannerSplit, LazyCmsBannerThin, LazyCmsBannerVideoParallax, LazyCmsBaseCaption, LazyCmsBaseButtonAction, LazyCmsBaseButtonCvent, LazyCmsBaseButtonEnroll, LazyCmsBaseButtonSimple, LazyCmsBaseExpandableCta, LazyCmsBaseEyebrow, LazyCmsBaseGradient, LazyCmsBaseParallaxLayer, LazyCmsBaseParallaxMedia, LazyCmsBaseResponsiveMedia, LazyCmsBenefitBar, LazyCmsBloomreachRecommendations, LazyCmsCategoryCard, LazyCmsCollection, LazyCmsCollectionColumnGallery, LazyCmsCollectionParallax, LazyCmsCollectionStandard, LazyCmsCollectionVerticalList, LazyCmsComingSoon, LazyCmsCountdown, LazyCmsCtaButtonCollection, LazyCmsCtaButton, LazyCmsDialog, LazyCmsDialogGeneric, LazyCmsExperiment, LazyCmsFilterBy, LazyCmsFooterItem, LazyCmsHero, LazyCmsHeroBlockBelow, LazyCmsHeroProductOverlay, LazyCmsHeroStandard, LazyCmsIconAndTextCollection, LazyCmsLayoutArticleV2, LazyCmsLayoutArticle, LazyCmsLinkedCard, LazyCmsLoyaltyBanner, LazyCmsMegaMenu, LazyCmsMegaMenuL1, LazyCmsMegaMenuL2, LazyCmsMegaMenuL2Desktop, LazyCmsMegaMenuL3, LazyCmsMegaMenuL3Desktop, LazyCmsMegaMenuL3Mobile, LazyCmsMegaMenuMobile, LazyCmsMegaMenuVisualSelector, LazyCmsMegaMenuVisualSelectorCollection, LazyCmsMultiLinkCard, LazyCmsNewsletterSignup, LazyCmsParallax, LazyCmsParallaxGallery, LazyCmsPicture, LazyCmsPlainText, LazyCmsPopUp, LazyCmsPopUpManager, LazyCmsProductFeatures, LazyCmsProductFinder, LazyCmsProductGridInternal, LazyCmsProductGrid, LazyCmsRichText, LazyCmsRichTextAdvanced, LazyCmsRichTextSimple, LazyCmsRichTextStandard, LazyCmsSecondaryNavigation, LazyCmsSectionPositionProvider, LazyCmsSection, LazyCmsSegmentation, LazyCmsSharedButton, LazyCmsSharedCtaGroup, LazyCmsSharedHotZones, LazyCmsSharedHotZonesProductCard, LazyCmsSharedMedia, LazyCmsShopTheLookGallery, LazyCmsShopTheLookMosaic, LazyCmsShowcaseControls, LazyCmsShowcaseFrame, LazyCmsShowcaseViewer, LazyCmsSignIn, LazyCmsSpacer, LazyCmsThinBanner, LazyCmsUgc, LazyCmsUgcCuralate, LazyCmsUgcOlapic, LazyCmsUgcSocialNative, LazyCmsUgcSocialNativeMasonry, LazyCmsVideoPlayer, LazyCmsVideoCloudinaryPlayer, LazyCmsVideo, LazyDialogContent, LazyDialogMobileFilters, LazyDialogSocialNative, LazyDialogSocialNativeContent, LazyDialogSocialNativeReport, LazyDialogAddYourPhoto, LazyDialogAskMeAnythingSearch, LazyDialogAskQuestion, LazyDialogAskQuestionSuccess, LazyDialogBarcode, LazyDialogBopisStoreSearch, LazyDialogCartChangeShippingMethod, LazyDialogCartItemActionMenu, LazyDialogCartValidateShippingAddress, LazyDialogChangeStoreConfirmation, LazyDialogCreditedConsumerTerms, LazyDialogEmployeeTerms, LazyDialogEuLegalGuarantee, LazyDialogForgotPassword, LazyDialogInfo, LazyDialogInterests, LazyDialogKlarna, LazyDialogLanguagePreference, LazyDialogLoyaltyRedeemHybrid, LazyDialogLoyaltyRedeem, LazyDialogLoyaltySignUp, LazyDialogMarketingEnrollment, LazyDialogMiniCart, LazyDialogNotifyMe, LazyDialogPayconiq, LazyDialogPickupInStoreReserve, LazyDialogProductDetailCard, LazyDialogProductReviews, LazyDialogProfileEnrichment, LazyDialogQuickshop, LazyDialogReportIssue, LazyDialogReviewUgc, LazyDialogReviewWrite, LazyDialogSignInAmazonSignOut, LazyDialogSignIn, LazyDialogSignInConfirmation, LazyDialogSignUp, LazyDialogSimplifiedEnrollment, LazyDialogSizeChart, LazyDialogStoreChanged, LazyDialogTermsAcceptance, LazyDialogTermsAndConditions, LazyDialogTest, LazyDialogThreeDsChallenge, LazyDialogVariantSelection, LazyDialogVideo, LazyDialogWelcome, LazyDialogYoutube } from '#components'
const lazyGlobalComponents = [
  ["DialogAccountMenu", LazyDialogAccountMenu],
["DialogAddCreditCard", LazyDialogAddCreditCard],
["DialogAddress", LazyDialogAddress],
["DialogBirthdayClaim", LazyDialogBirthdayClaim],
["DialogCancelOrder", LazyDialogCancelOrder],
["DialogCreditHowItWorks", LazyDialogCreditHowItWorks],
["DialogDeleteAddress", LazyDialogDeleteAddress],
["DialogDeleteCard", LazyDialogDeleteCard],
["DialogMoreWaysToEarnOffer", LazyDialogMoreWaysToEarnOffer],
["DialogMoreWaysToEarn", LazyDialogMoreWaysToEarn],
["DialogSmsNotifications", LazyDialogSmsNotifications],
["DialogTrackOrder", LazyDialogTrackOrder],
["DialogTrackShipments", LazyDialogTrackShipments],
["CmsEventCollection", LazyCmsEventCollection],
["CmsMegaMenuL1Desktop", LazyCmsMegaMenuL1Desktop],
["CmsMegaMenuL1DesktopLegacy", LazyCmsMegaMenuL1DesktopLegacy],
["CmsMegaMenuL1DesktopV2", LazyCmsMegaMenuL1DesktopV2],
["CmsMegaMenuL1Mobile", LazyCmsMegaMenuL1Mobile],
["CmsMegaMenuL2Mobile", LazyCmsMegaMenuL2Mobile],
["CmsPromoBar", LazyCmsPromoBar],
["CmsPromoBarLinks", LazyCmsPromoBarLinks],
["CmsPromoBarMessage", LazyCmsPromoBarMessage],
["CmsPromoBarUtilities", LazyCmsPromoBarUtilities],
["CmsRecommendationCarousel", LazyCmsRecommendationCarousel],
["DialogAddGiftOption", LazyDialogAddGiftOption],
["DialogAccount", LazyDialogAccount],
["DialogEventDetail", LazyDialogEventDetail],
["DialogFilters", LazyDialogFilters],
["DialogHowMetersWorks", LazyDialogHowMetersWorks],
["DialogLocationConfirmation", LazyDialogLocationConfirmation],
["DialogMegaMenu", LazyDialogMegaMenu],
["DialogPickupInStore", LazyDialogPickupInStore],
["DialogProductDetails", LazyDialogProductDetails],
["DialogPromoBar", LazyDialogPromoBar],
["DialogQuickshopElevate", LazyDialogQuickshopElevate],
["DialogShippingAddress", LazyDialogShippingAddress],
["DialogShopTheLook", LazyDialogShopTheLook],
["CmsAccordions", LazyCmsAccordions],
["CmsAnchor", LazyCmsAnchor],
["CmsArticleCarousel", LazyCmsArticleCarousel],
["CmsArticleGridV2", LazyCmsArticleGridV2],
["CmsArticleGrid", LazyCmsArticleGrid],
["CmsBannerBlockBelow", LazyCmsBannerBlockBelow],
["CmsBannerBlurredSplit", LazyCmsBannerBlurredSplit],
["CmsBannerEspot", LazyCmsBannerEspot],
["CmsBannerImage", LazyCmsBannerImage],
["CmsBannerImageStandard", LazyCmsBannerImageStandard],
["CmsBannerMenu", LazyCmsBannerMenu],
["CmsBannerOverlay", LazyCmsBannerOverlay],
["CmsBannerSaleSplit", LazyCmsBannerSaleSplit],
["CmsBannerSplit", LazyCmsBannerSplit],
["CmsBannerThin", LazyCmsBannerThin],
["CmsBannerVideoParallax", LazyCmsBannerVideoParallax],
["CmsBaseCaption", LazyCmsBaseCaption],
["CmsBaseButtonAction", LazyCmsBaseButtonAction],
["CmsBaseButtonCvent", LazyCmsBaseButtonCvent],
["CmsBaseButtonEnroll", LazyCmsBaseButtonEnroll],
["CmsBaseButtonSimple", LazyCmsBaseButtonSimple],
["CmsBaseExpandableCta", LazyCmsBaseExpandableCta],
["CmsBaseEyebrow", LazyCmsBaseEyebrow],
["CmsBaseGradient", LazyCmsBaseGradient],
["CmsBaseParallaxLayer", LazyCmsBaseParallaxLayer],
["CmsBaseParallaxMedia", LazyCmsBaseParallaxMedia],
["CmsBaseResponsiveMedia", LazyCmsBaseResponsiveMedia],
["CmsBenefitBar", LazyCmsBenefitBar],
["CmsBloomreachRecommendations", LazyCmsBloomreachRecommendations],
["CmsCategoryCard", LazyCmsCategoryCard],
["CmsCollection", LazyCmsCollection],
["CmsCollectionColumnGallery", LazyCmsCollectionColumnGallery],
["CmsCollectionParallax", LazyCmsCollectionParallax],
["CmsCollectionStandard", LazyCmsCollectionStandard],
["CmsCollectionVerticalList", LazyCmsCollectionVerticalList],
["CmsComingSoon", LazyCmsComingSoon],
["CmsCountdown", LazyCmsCountdown],
["CmsCtaButtonCollection", LazyCmsCtaButtonCollection],
["CmsCtaButton", LazyCmsCtaButton],
["CmsDialog", LazyCmsDialog],
["CmsDialogGeneric", LazyCmsDialogGeneric],
["CmsExperiment", LazyCmsExperiment],
["CmsFilterBy", LazyCmsFilterBy],
["CmsFooterItem", LazyCmsFooterItem],
["CmsHero", LazyCmsHero],
["CmsHeroBlockBelow", LazyCmsHeroBlockBelow],
["CmsHeroProductOverlay", LazyCmsHeroProductOverlay],
["CmsHeroStandard", LazyCmsHeroStandard],
["CmsIconAndTextCollection", LazyCmsIconAndTextCollection],
["CmsLayoutArticleV2", LazyCmsLayoutArticleV2],
["CmsLayoutArticle", LazyCmsLayoutArticle],
["CmsLinkedCard", LazyCmsLinkedCard],
["CmsLoyaltyBanner", LazyCmsLoyaltyBanner],
["CmsMegaMenu", LazyCmsMegaMenu],
["CmsMegaMenuL1", LazyCmsMegaMenuL1],
["CmsMegaMenuL2", LazyCmsMegaMenuL2],
["CmsMegaMenuL2Desktop", LazyCmsMegaMenuL2Desktop],
["CmsMegaMenuL3", LazyCmsMegaMenuL3],
["CmsMegaMenuL3Desktop", LazyCmsMegaMenuL3Desktop],
["CmsMegaMenuL3Mobile", LazyCmsMegaMenuL3Mobile],
["CmsMegaMenuMobile", LazyCmsMegaMenuMobile],
["CmsMegaMenuVisualSelector", LazyCmsMegaMenuVisualSelector],
["CmsMegaMenuVisualSelectorCollection", LazyCmsMegaMenuVisualSelectorCollection],
["CmsMultiLinkCard", LazyCmsMultiLinkCard],
["CmsNewsletterSignup", LazyCmsNewsletterSignup],
["CmsParallax", LazyCmsParallax],
["CmsParallaxGallery", LazyCmsParallaxGallery],
["CmsPicture", LazyCmsPicture],
["CmsPlainText", LazyCmsPlainText],
["CmsPopUp", LazyCmsPopUp],
["CmsPopUpManager", LazyCmsPopUpManager],
["CmsProductFeatures", LazyCmsProductFeatures],
["CmsProductFinder", LazyCmsProductFinder],
["CmsProductGridInternal", LazyCmsProductGridInternal],
["CmsProductGrid", LazyCmsProductGrid],
["CmsRichText", LazyCmsRichText],
["CmsRichTextAdvanced", LazyCmsRichTextAdvanced],
["CmsRichTextSimple", LazyCmsRichTextSimple],
["CmsRichTextStandard", LazyCmsRichTextStandard],
["CmsSecondaryNavigation", LazyCmsSecondaryNavigation],
["CmsSectionPositionProvider", LazyCmsSectionPositionProvider],
["CmsSection", LazyCmsSection],
["CmsSegmentation", LazyCmsSegmentation],
["CmsSharedButton", LazyCmsSharedButton],
["CmsSharedCtaGroup", LazyCmsSharedCtaGroup],
["CmsSharedHotZones", LazyCmsSharedHotZones],
["CmsSharedHotZonesProductCard", LazyCmsSharedHotZonesProductCard],
["CmsSharedMedia", LazyCmsSharedMedia],
["CmsShopTheLookGallery", LazyCmsShopTheLookGallery],
["CmsShopTheLookMosaic", LazyCmsShopTheLookMosaic],
["CmsShowcaseControls", LazyCmsShowcaseControls],
["CmsShowcaseFrame", LazyCmsShowcaseFrame],
["CmsShowcaseViewer", LazyCmsShowcaseViewer],
["CmsSignIn", LazyCmsSignIn],
["CmsSpacer", LazyCmsSpacer],
["CmsThinBanner", LazyCmsThinBanner],
["CmsUgc", LazyCmsUgc],
["CmsUgcCuralate", LazyCmsUgcCuralate],
["CmsUgcOlapic", LazyCmsUgcOlapic],
["CmsUgcSocialNative", LazyCmsUgcSocialNative],
["CmsUgcSocialNativeMasonry", LazyCmsUgcSocialNativeMasonry],
["CmsVideoPlayer", LazyCmsVideoPlayer],
["CmsVideoCloudinaryPlayer", LazyCmsVideoCloudinaryPlayer],
["CmsVideo", LazyCmsVideo],
["DialogContent", LazyDialogContent],
["DialogMobileFilters", LazyDialogMobileFilters],
["DialogSocialNative", LazyDialogSocialNative],
["DialogSocialNativeContent", LazyDialogSocialNativeContent],
["DialogSocialNativeReport", LazyDialogSocialNativeReport],
["DialogAddYourPhoto", LazyDialogAddYourPhoto],
["DialogAskMeAnythingSearch", LazyDialogAskMeAnythingSearch],
["DialogAskQuestion", LazyDialogAskQuestion],
["DialogAskQuestionSuccess", LazyDialogAskQuestionSuccess],
["DialogBarcode", LazyDialogBarcode],
["DialogBopisStoreSearch", LazyDialogBopisStoreSearch],
["DialogCartChangeShippingMethod", LazyDialogCartChangeShippingMethod],
["DialogCartItemActionMenu", LazyDialogCartItemActionMenu],
["DialogCartValidateShippingAddress", LazyDialogCartValidateShippingAddress],
["DialogChangeStoreConfirmation", LazyDialogChangeStoreConfirmation],
["DialogCreditedConsumerTerms", LazyDialogCreditedConsumerTerms],
["DialogEmployeeTerms", LazyDialogEmployeeTerms],
["DialogEuLegalGuarantee", LazyDialogEuLegalGuarantee],
["DialogForgotPassword", LazyDialogForgotPassword],
["DialogInfo", LazyDialogInfo],
["DialogInterests", LazyDialogInterests],
["DialogKlarna", LazyDialogKlarna],
["DialogLanguagePreference", LazyDialogLanguagePreference],
["DialogLoyaltyRedeemHybrid", LazyDialogLoyaltyRedeemHybrid],
["DialogLoyaltyRedeem", LazyDialogLoyaltyRedeem],
["DialogLoyaltySignUp", LazyDialogLoyaltySignUp],
["DialogMarketingEnrollment", LazyDialogMarketingEnrollment],
["DialogMiniCart", LazyDialogMiniCart],
["DialogNotifyMe", LazyDialogNotifyMe],
["DialogPayconiq", LazyDialogPayconiq],
["DialogPickupInStoreReserve", LazyDialogPickupInStoreReserve],
["DialogProductDetailCard", LazyDialogProductDetailCard],
["DialogProductReviews", LazyDialogProductReviews],
["DialogProfileEnrichment", LazyDialogProfileEnrichment],
["DialogQuickshop", LazyDialogQuickshop],
["DialogReportIssue", LazyDialogReportIssue],
["DialogReviewUgc", LazyDialogReviewUgc],
["DialogReviewWrite", LazyDialogReviewWrite],
["DialogSignInAmazonSignOut", LazyDialogSignInAmazonSignOut],
["DialogSignIn", LazyDialogSignIn],
["DialogSignInConfirmation", LazyDialogSignInConfirmation],
["DialogSignUp", LazyDialogSignUp],
["DialogSimplifiedEnrollment", LazyDialogSimplifiedEnrollment],
["DialogSizeChart", LazyDialogSizeChart],
["DialogStoreChanged", LazyDialogStoreChanged],
["DialogTermsAcceptance", LazyDialogTermsAcceptance],
["DialogTermsAndConditions", LazyDialogTermsAndConditions],
["DialogTest", LazyDialogTest],
["DialogThreeDsChallenge", LazyDialogThreeDsChallenge],
["DialogVariantSelection", LazyDialogVariantSelection],
["DialogVideo", LazyDialogVideo],
["DialogWelcome", LazyDialogWelcome],
["DialogYoutube", LazyDialogYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
